/* eslint-disable space-before-function-paren */
import Vue from 'vue'

// loading圆形
// 传参方式{data:20}或者{data:[分子,分母]}
// color:'red',lineWidth:6,fontSize:18,lineBgColor:'#ffffff'
Vue.directive('loadingRound', {
    update: function (el, binding, vnode, oldVnode) {
        let getList = binding.value
        let pointData = 0 // 数据圆的值（根据圆计算占比）
        let pointTxt = 0 // 中间动态部分的值（分子或者百分比）
        let txtEnd = '' // 中间文字非动态部分（%或者/分母）
        if (getList.data.constructor === Array) {
            // if (getList.data[0] === 0) {
            //   el.innerHTML = '0/' + getList.data[1]
            //   return
            // } // 如果分子为0就不用往下执行
            // 如果data是一个数组[分子，分母]
            let pointRotate = 2 * Math.PI * (getList.data[0] / getList.data[1])
            pointData = pointRotate > 2 * Math.PI ? 2 * Math.PI : pointRotate // 如果大于一个圆，就让它等于圆（分子>分母）
            pointTxt = getList.data[0]
            txtEnd = '/' + getList.data[1]
        } else {
            if (binding.value.data > 0 && el.valueDirective === binding.value.data && el.widthDirective === el.clientWidth) {
                return false
            } // 相同值不更新
            el.valueDirective = binding.value.data
            el.widthDirective = el.clientWidth
            // if (getList.data === 0) {
            //   el.innerHTML = "0%";
            //   return;
            // } // 如果data为0就不用往下执行
            // 如果data是一个数字
            pointData = 2 * Math.PI * (getList.data / 100)
            pointTxt = getList.data
            txtEnd = '%'
        }
        el.UpdatepointData = pointData
        el.innerHTML = ''
        let height = el.clientHeight // 获取高度
        let width = el.clientWidth // 获取宽度
        let lineWidth = getList.lineWidth || 4 // 圆宽度
        let fontSize = getList.fontSize || 16 // 字体
        let r = width / 2 // 中间位置;
        let cR = r - 0.5 * lineWidth // 圆半径
        var startAngle = -((1 / 2) * Math.PI) // 开始角度
        let canvas = document.createElement('canvas') // 创建canvas
        canvas.width = width
        canvas.height = height
        el.appendChild(canvas)
        var ctx = canvas.getContext('2d')
        var gradient = ctx.createLinearGradient(0, 0, 170, 0)
        gradient.addColorStop('0', '#058df9')
        gradient.addColorStop('0.5', '#6eb8f3')
        gradient.addColorStop('1.0', '#b4e2f7')
        let lang = el.UpdatepointData - (1 / 2) * Math.PI // 进度条换算进度条总长度
        let langCount = Math.abs(el.UpdatepointData / 100) // 进度条取绝对值执行100次
        let filleColor = getList.color || gradient // 如果有传过来color就用color,没有就默认蓝色渐变
        let fontColor = getList.fontColor || filleColor // 字体颜色如果有传值就优先用传过来的值
        let drawW = startAngle // 进度条从初始值开始画（十二点方向开始是负数1.57左右）
        let txtBegin = 0 // 文字部分从0开始动态++
        let txtTotal = parseFloat((pointTxt / 100).toFixed(2)) // 文字取绝对值执行100次，保留两位小数
        // 开始画进度条
        let stop = null
        let Listener = function () {
            if (el) {
                el.children[0].style.height = el.clientHeight + 'px'
                el.children[0].style.width = el.clientWidth + 'px'
            }
            var rander = function () {
                stop = requestAnimationFrame(rander)
                if (!r) {
                    cancelAnimationFrame(stop)
                    stop = null
                    return false
                }
                // 进度条
                if (drawW < lang) drawW += langCount
                else if (drawW > lang) drawW = lang
                // 文字
                if (txtBegin < pointTxt) {
                    txtBegin = (parseFloat(txtBegin) + parseFloat(txtTotal)).toFixed(2)
                } else if (txtBegin >= pointTxt) {
                    txtBegin = pointTxt
                    cancelAnimationFrame(stop)
                }
                ctx.clearRect(0, 0, width, height) // 清空后再画，避免出现锯齿
                // 底圆
                ctx.beginPath()
                ctx.arc(r, r, cR, startAngle, 2 * Math.PI)
                ctx.lineWidth = lineWidth
                ctx.strokeStyle = getList.lineBgColor || '#E6E6E6'
                ctx.stroke()
                // 数据圆
                ctx.beginPath()
                ctx.lineWidth = lineWidth
                ctx.strokeStyle = filleColor
                ctx.lineCap = 'round'
                ctx.arc(r, r, cR, startAngle, drawW)
                ctx.stroke()
                // 写字
                ctx.fillStyle = fontColor
                ctx.font = fontSize / 100 + 'rem alternate'
                ctx.textAlign = 'center'
                let val = pointTxt.toString().indexOf('.') > 0 ? txtBegin : parseInt(txtBegin) // 如果值是整数，就只展示整数
                ctx.fillText(val + txtEnd, r, r + fontSize / 2)
            }
            rander()
        }
        Listener()
        el.unbindresize = () => {
            Vue.prototype.$listen('resize', Listener)
        }
        Vue.prototype.$listen('resize', Listener, 'add')
    },
    unbind: function (el) {
        el.unbindresize && el.unbindresize()
    }
})

// loading条形
Vue.directive('loadingBar', {
    inserted: function (el, binding, vnode, oldVnode) {
        let getBinding = binding.value
        let data = getBinding.data === 0 ? 0 : getBinding.data || getBinding
        el.updatedatas = data
        if (data && binding.oldValue && data === binding.oldValue.data) return // 相同值不操作
        el.innerHTML = ''
        let filleColor = getBinding.color || '#66BB6A'
        el.style.display = 'flex'
        el.style.position = 'relative'
        el.style['box-sizing'] = 'content-box'
        if (getBinding.border) el.style.border = `1px solid ${getBinding.border}`
        let height = el.clientHeight // 获取高度
        let width = el.clientWidth // 获取宽度
        el.style.width = width + 'px'
        let canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        var drawW = !binding.oldValue || binding.oldValue.data > data ? 0 : data // 进度条从0开始画
        var boxMotion = function (canvas, width, judge, drawW = 0, data) {
            canvas.width = width
            canvas.height = height
            ctx.fillStyle = getBinding.backgroundColor || '#e6e6e6' // 灰色底条
            ctx.fillRect(0, 0, width, height)
            let lang = (el.updatedatas * width) / 100 // 换算进度条总长度
            let langCount = Math.abs(lang / el.updatedatas) // 取绝对值执行data(百分比)次
            ctx.fillStyle = filleColor
            if (judge) {
                ctx.fillRect(0, 0, lang, height)
            }
            var rander = function () {
                if (drawW < lang) {
                    drawW += langCount
                    ctx.fillRect(0, 0, drawW, height)
                } else if (drawW >= lang) {
                    // 如果大于原本的数值就让它等于它
                    drawW = langCount
                    ctx.fillRect(0, 0, drawW, height)
                    clearInterval(el.__vueReize__)
                } else if (!drawW >= 0 || !lang >= 0) {
                    clearInterval(el.__vueReize__)
                }
            }
            if (drawW >= 0 && lang >= 0) el.__vueReize__ = setInterval(rander, 16.7)
        }
        el.appendChild(canvas)
        el.canvasEV = canvas
        el.canvasWidth = width
        el.updateData = boxMotion
        var setVessel = judge => {
            clearInterval(el.__vueReize__)
            el.style.width = el.parentElement.offsetWidth + 'px'
            boxMotion(canvas, el.parentElement.offsetWidth, judge, drawW)
        }
        setVessel()
        el.__setVessel__ = setVessel
        // 对事件进行监听
        Vue.prototype.$listen('resize', setVessel, 'add')
    },
    update: function (el, binding, vnode, oldVnode) {
        let getBinding = binding.value
        let data = getBinding.data === 0 ? 0 : getBinding.data || getBinding
        if (data && binding.oldValue && data === binding.oldValue.data) return // 相同值不操作
        el.updatedatas = data
        var drawW = binding.oldValue.data || 0 // 进度条从0开始画
        if (el.updateData) {
            clearInterval(el.__vueReize__)
            el.updateData(el.canvasEV, el.canvasWidth, false, drawW)
        }
    },
    unbind(el) {
        clearInterval(el.__vueReize__)
        Vue.prototype.$listen('resize', el.__setVessel__)
    }
})

const countRunningFun = (el, binding, vnode, oldVnode) => {
    el.style['font-family'] = 'alternate'
    const data = parseFloat(binding.value) // 传回来的数值目标值
    let addNumber = 1.11
    if (data > 200) addNumber = data / 100
    else if (data > 100 && data < 200) addNumber = 2.22
    // const countPoint = data / 100
    let nowCount = 0 // 当前页面显示值
    let totalCount = 0 // 数值每次变化做记录
    let goNumber = data > 200 ? 200 : 100 // 执行次数
    // 回调函数
    var stop = null
    let render = function () {
        // 在动画没有结束前，递归渲染
        stop = requestAnimationFrame(render)
        if (nowCount < data && totalCount < goNumber) {
            if (data.toString().indexOf('.') > 0) {
                // 如果包含小数点表示是小数
                let cutVal = data.toString().split('.')[1].length // 小数点个数
                if (cutVal === 1) {
                    // 包含1个小数点
                    nowCount = (parseFloat(nowCount) + parseFloat(addNumber)).toFixed(1)
                } else {
                    // 包含多个小数点就只保留两位小数点
                    nowCount = (parseFloat(nowCount) + parseFloat(addNumber)).toFixed(2)
                }
            } else {
                nowCount = (parseFloat(nowCount) + parseFloat(addNumber)).toFixed(0)
            }
            totalCount++
        } else if (nowCount !== data && totalCount === goNumber) {
            // 控制时间最多1000毫秒（10*100）,大于1000次就直接赋值，不允许无限制滚动
            nowCount = data
            el.innerHTML = getNUm(nowCount)
        } else if (nowCount >= data) {
            nowCount = data
            cancelAnimationFrame(stop) // 可以取消该次动画。
            el.innerHTML = getNUm(nowCount)
        }
        el.innerHTML = getNUm(nowCount)
    }
    render()
}

// 数字滚动指令
Vue.directive('countRunning', {
    bind(el, binding, vnode, oldVnode) {
        countRunningFun(el, binding, vnode, oldVnode)
    },
    update(el, binding, vnode, oldVnode) {
        if (binding.value === binding.oldValue) return // 相同值不操作
        countRunningFun(el, binding, vnode, oldVnode)
        // var timer=null
        // timer = setInterval(() => {
        //   if (nowCount < targetDomCount && totalCount < 100) {
        //     //最多执行一百次
        //     if (targetDomCount.toString().indexOf(".") > 0) {
        //       //如果包含小数点表示是小数
        //       let cutVal = targetDomCount.toString().split(".")[1].length; //小数点个数
        //       if (cutVal === 1) {
        //         //包含1个小数点
        //         nowCount = (parseFloat(nowCount) + parseFloat(countPoint)).toFixed(
        //           1
        //         );
        //       } else {
        //         //包含多个小数点就只保留两位小数点
        //         nowCount = (parseFloat(nowCount) + parseFloat(countPoint)).toFixed(
        //           2
        //         );
        //       }
        //     } else {
        //       nowCount++;
        //     }
        //     console.log(nowCount);
        //     totalCount++;
        //   } else if (
        //     nowCount > targetDomCount ||
        //     (nowCount < targetDomCount && totalCount === 100)
        //   ) {
        //     // 控制时间最多1000毫秒（10*100）,大于1000次就直接赋值，不允许无限制滚动
        //     nowCount = targetDomCount;
        //     clearInterval(timer);
        //     timer = null;
        //   } else {
        //     clearInterval(timer);
        //     timer = null;
        //   }
        //   el.innerHTML = nowCount;
        // }, 10);
    }
})

Vue.directive('removeAriaHidden', {
    bind(el, binding) {
        let ariaEls = el.querySelectorAll('.el-radio__original')
        ariaEls.forEach(item => {
            item.removeAttribute('aria-hidden')
        })
    }
})

// 拆分逗号
function getNUm(value) {
    let show = value.toString()
    let text = show
    if (show.indexOf('.') > 0) {
        return value
    }
    if (show.length > 3 && show.length <= 6) {
        text = show.substring(0, show.length - 3) + ',' + show.substring(show.length - 3, show.length)
    } else if (show.length > 6) {
        text = show.substring(0, show.length - 6) + ',' + show.substring(show.length - 6, show.length - 3) + ',' + show.substring(show.length - 3, show.length)
    }
    return text
}
// type(add表示添加)
Vue.prototype.$listen = function (name, callBack, type, init, ev) {
    if (!ev) {
        if (init) callBack()
        type === 'add' ? window.addEventListener(name, callBack) : window.removeEventListener(name, callBack)
    } else {
        let MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver
        let observer = new MutationObserver((mutationList, r) => {
            callBack(mutationList)
        })
        if (type === 'add') {
            observer.observe(ev.event, ev.objAttr)
        } else {
            observer.disconnect()
            // this.observer.takeRecords() // 通知队列中删除所有待处理的通知， 并将它们返回到一个MutationRecord对象构成的新数组中。
            observer = null
        }
    }
}

// 自定义过滤器如果是数组就用，隔开
Vue.filter('joinList', function (val) {
    let bakcVal = val.constructor === Array ? val.join(',') : val
    return bakcVal
})



// WEBPACK FOOTER //
// ./src/common/js/public.js